import { MouseEventHandler } from "react";
import "react-modern-drawer/dist/index.css";
import "./style.css";
import { Link } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "redux/store";
import { Icons } from "utils/iconPath";

const TopBar = ({ onClick }: { onClick?: MouseEventHandler }) => {
  // Global States
  const { sideBar } = useSelector(
    (state: RootState) => ({
      sideBar: state.sideBar,
    }),
    shallowEqual
  );
  return (
    <div className="topBar" data-aos="fade-down" id="topBar">
      <Link to={"/"} className="logoContainer clickable">
        <img className="logo" src={Icons.LOGO} alt="logo" />
      </Link>
      <div className="iconContainer " onClick={onClick}>
        <img
          src={sideBar?.drawerVisibility ? Icons?.CLOSE : Icons.MENU}
          alt="menu"
          className="icon"
        />
      </div>
    </div>
  );
};

export default TopBar;
